import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1.2",
  y: "1.2",
  width: "35.6",
  height: "35.6",
  rx: "17.8",
  "stroke-width": "2.4",
  class: "text-cebai-grey-mid stroke-current hover:text-cebai-grey-lightest fill-current transition"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "2.4",
  y: "2.4",
  width: "33.2",
  height: "33.2",
  rx: "16.6",
  class: "text-cebai-base-light hover:text-cebai-grey-lightest fill-current transition"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.9023 22.8789H17.1016C17.1094 22.168 17.168 21.5586 17.2773 21.0508C17.3945 20.543 17.5859 20.0859 17.8516 19.6797C18.1172 19.2656 18.4766 18.8438 18.9297 18.4141C19.2891 18.0781 19.6094 17.7617 19.8906 17.4648C20.1797 17.1602 20.4062 16.8438 20.5703 16.5156C20.7344 16.1797 20.8164 15.8008 20.8164 15.3789C20.8164 14.9023 20.7383 14.5039 20.582 14.1836C20.4336 13.8633 20.2109 13.6211 19.9141 13.457C19.625 13.2852 19.2617 13.1992 18.8242 13.1992C18.4648 13.1992 18.125 13.2734 17.8047 13.4219C17.4844 13.5703 17.2266 13.8008 17.0312 14.1133C16.8359 14.418 16.7305 14.8164 16.7148 15.3086H13.6094C13.6328 14.2852 13.875 13.4336 14.3359 12.7539C14.7969 12.0664 15.418 11.5547 16.1992 11.2188C16.9805 10.875 17.8555 10.7031 18.8242 10.7031C19.8945 10.7031 20.8086 10.8828 21.5664 11.2422C22.332 11.5938 22.9141 12.1094 23.3125 12.7891C23.7188 13.4688 23.9219 14.2891 23.9219 15.25C23.9219 15.9375 23.7891 16.5547 23.5234 17.1016C23.2578 17.6406 22.9062 18.1445 22.4688 18.6133C22.0312 19.082 21.5586 19.5547 21.0508 20.0312C20.6055 20.4297 20.3047 20.8555 20.1484 21.3086C19.9922 21.7617 19.9102 22.2852 19.9023 22.8789ZM16.8086 26.5234C16.8086 26.0547 16.9648 25.6641 17.2773 25.3516C17.5977 25.0391 18.0273 24.8828 18.5664 24.8828C19.1055 24.8828 19.5312 25.0391 19.8438 25.3516C20.1641 25.6641 20.3242 26.0547 20.3242 26.5234C20.3242 26.9766 20.1641 27.3594 19.8438 27.6719C19.5312 27.9844 19.1055 28.1406 18.5664 28.1406C18.0273 28.1406 17.5977 27.9844 17.2773 27.6719C16.9648 27.3594 16.8086 26.9766 16.8086 26.5234Z",
  class: "text-cebai-primary fill-current"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}